import { Icon } from '@iconify/react';
import { SidebarNavGroup, SidebarNavItem } from '@ipen/components';
import { Link, useLocation } from 'react-router-dom';

type CommunitySubItem = {
  label: string;
  to: string;
  type: string;
};

const COMMUNITY_ITEMS: readonly CommunitySubItem[] = [
  {
    label: 'DSOs',
    to: '/catalog?filters[kind]=group&filters[type]=organisation-dso&filters[user]=all',
    type: 'organisation-dso',
  },
  {
    label: 'Chapter',
    to: '/catalog?filters[kind]=group&filters[type]=chapter&filters[user]=all',
    type: 'chapter',
  },
  {
    label: 'Squads',
    to: '/catalog?filters[kind]=group&filters[type]=squad&filters[user]=all',
    type: 'squad',
  },
];

type Props = {
  className?: string;
};

export const BackstageCommunityNavigation = ({
  className,
}: Props) => {
  const location = useLocation();

  const isCatalog = location.pathname === '/catalog';
  const searchParams = new URLSearchParams(location.search);
  const isGroup = searchParams.get('filters[kind]') === 'group';
  const activeType = searchParams.get('filters[type]');

  const activeSubItem = isCatalog && isGroup
    ? COMMUNITY_ITEMS.find(item => item.type === activeType)
    : undefined;

  const isGroupActive = activeSubItem !== undefined;

  return (
    <SidebarNavGroup
      active={isGroupActive}
      className={className}
      icon={<Icon icon="ri:team-line" />}
      label="Community"
    >
      {COMMUNITY_ITEMS.map(item => (
        <SidebarNavItem
          component={Link}
          key={item.to}
          {...item}
          active={item === activeSubItem}
        />
      ))}
    </SidebarNavGroup>
  );
};
